import Header from "../../components/ui/header";
import CollapsibleCard from "../../components/ui/accordion";
import { formatCurrencyAbs } from "../../components/ui/money";

type HistoryPowerRecordType = Record<string, Record<string, any>>;

const i18n: Record<string, string> = {
  electricity: "Електроенергія",
  losses: "Нарахування",
  current_reading: "Поточні",
  previous_reading: "Попередні",
  reading_difference: "Різниця",
  day: "День",
  night: "Ніч",
  year: "Рік",
  once: "Одноразово",
  cash: "Готівка",
  bank: "Банк",
  total: 'Разом',
};

const allowedKeys: Record<string, string> = {
  // registrar_number: "№ Документа",
  dateTime: "Дата",
  current_reading: "Поточні",
  previous_reading: "Попередні",
  reading_difference: "Різниця",
  dayNight: "День/Ніч",
  bankCash: "Джерело платежу",
  amount: "Сума",
};

const allowedHeadersAmount: Record<string, string> = {
  Expense: 'Сплачено',
  // FinalBalance: 'Залишок',
  // InitialBalance: 'Нараховано',
};

const allowedKeysAmount: Record<string, string> = {
  expense: 'Сплачено',
  final_balance: 'Залишок',
  initial_balance: 'Нараховано',
};

type RenderHistoryPowerRecordProps = {
  history: Record<string, any>;
  account: string;
  sortedKeys: string[];
  includeKeys?: string[];
  excludeKeys?: string[];
};

const RenderHistoryPowerRecord: React.FC<RenderHistoryPowerRecordProps> = (
  {
    history,
    account,
    sortedKeys,
    includeKeys = [],
    excludeKeys = [],
  }) => {

  const tI18n = (key: string) => {
    const translation = i18n[key];
    return translation ? translation : key;
  }

  const tAllowedKeys = (key: string) => {
    const translation = allowedKeys[key];
    return translation ? translation : key;
  }

  const tAllowedKeysAmount = (key: string) => {
    const translation = allowedKeysAmount[key];
    return translation ? translation : key;
  }

  const renderHistoryPowerItem = (key: string) => {
    // Check if includeKeys is empty and excludeKeys does not contain the key
    if (includeKeys.length === 0 && !excludeKeys.includes(key)) {
      return true; // Render the item
    }
    // If it's in includeKeys and not in excludeKeys, render the item
    if (includeKeys.includes(key) && !excludeKeys.includes(key)) {
      return true; // Render the item
    }
    // If it's in excludeKeys, do not render the item
    if (excludeKeys.includes(key)) {
      return false; // Do not render the item
    }
    return false; // Default case if none of the conditions are met
  };

  return (
    <div
      key={`title-${account}-${Math.random()}`}
      className="bg-white mb-4"
    >
      <div>
        <div className="text-sm overflow-x-auto">
          <table className="table-auto w-full">
            <thead>
            <tr>
              {Object.entries(allowedKeys)?.map(([key, translate]: [string, any]) => {
                if (key === "amount") {
                  return Object.entries(allowedHeadersAmount)?.map(([keyA, translateA]: [string, any]) => {
                    return (
                      <th className="border border-gray-200 text-red-700"
                          key={`${history?.[0]?.["dateTime"]}-${key}-${keyA}`}>
                        {translateA}
                      </th>
                    )
                  })
                }
                return (
                  <th className="border border-gray-200 text-red-700"
                      key={`${history?.[0]?.["dateTime"]}-${key}`}>{translate}</th>
                )
              })}
            </tr>
            </thead>
            <tbody className={"text-sm text-gray-900"}>
            {Object.values(sortedKeys)?.map((dateTime: string) => {
              let sumDayNight = NaN;
              let sumReadingDifference = 0;
              return (
                <>
                  {Object.entries(history?.[dateTime] || {})?.map(([noRecord, entry]: [string, any]) => {
                    return (
                      <tr key={`tr-${dateTime}-${noRecord}`}
                          className={entry["dayNight"] === "day" ? "bg-amber-50" : (entry["dayNight"] === "night" ? "bg-indigo-50" : "")}
                      >
                        {
                          Object.entries(allowedKeys)?.map(([key, translate]: [string, any]) => {
                            if (!renderHistoryPowerItem(entry["service"])) return null;
                            if (key === "reading_difference") {
                              sumReadingDifference += (parseFloat(entry?.[key]) || 0);
                            }
                            if (key === "amount") {
                              if (isNaN(sumDayNight)) sumDayNight = 0;
                              sumDayNight += (parseFloat(entry?.[key]?.["Expense"]) || 0);
                              return Object.entries(allowedHeadersAmount)?.map(([keyA, translateA]: [string, any]) => {
                                return (
                                  <td className="border border-gray-200 text-left p-2"
                                      key={`${dateTime}-${noRecord}-${key}-${keyA}`}>
                                    {formatCurrencyAbs(entry[key][keyA] ? entry[key][keyA] : "0.0")}
                                  </td>
                                )
                              })
                            }
                            if (entry[key]) {
                              if (key === "current_reading" || key === "previous_reading") {
                                entry[key] = String(entry[key]).replace(/[,\.]/g, '');
                              }
                            }
                            return (entry[key] ? (
                                <td className="border border-gray-200 text-left p-2"
                                    key={`${dateTime}-${noRecord}-${key}`}>
                                  {tI18n(entry[key]?.toString())}
                                </td>) : (
                                <td className="border border-gray-200 text-left p-2"
                                    key={`${dateTime}-${noRecord}-${key}`}>
                                  -
                                </td>)
                            )
                          })
                        }
                      </tr>
                    )
                  })}
                  {!isNaN(sumDayNight) && sumDayNight !== 0 && (
                    <tr key={`sum-${dateTime}`} className="">
                      <td className="border border-gray-200 text-right pr-2 font-bold"
                          colSpan={Object.keys(allowedKeys).length - 4}>
                        {tI18n("total")}
                      </td>
                      <td className="border border-gray-200 text-left pl-2 font-bold">
                        {Math.abs(sumReadingDifference)}
                      </td>
                      <td className="border border-gray-200 text-left pl-2 font-bold">
                      </td>
                      <td className="border border-gray-200 text-left pl-2 font-bold">
                      </td>
                      <td className="border border-gray-200 text-left pl-2 font-bold">
                        {formatCurrencyAbs(sumDayNight)}
                      </td>
                    </tr>
                  )}
                </>
              )
            })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
};

export const HistoryPowerViewer = (
  {
    history,
    sortedKeys,
    account,
    openState = false,
    title = "",
    includeKeys = [],
    excludeKeys = []
  }: {
    history: HistoryPowerRecordType
    sortedKeys: string[]
    account: string
    title?: string
    includeKeys?: string[];
    excludeKeys?: string[];
    openState?: boolean
    className?: string
  }) => {
  return (
    <Header className={"border rounded-lg"} key={`header-${account || ''}`}>
      <CollapsibleCard title={title || ''} open={openState || false} className="grid grid-cols-1 divide-y" more={false}>
        <RenderHistoryPowerRecord
          key={`RenderRecord-${account}`}
          history={history}
          account={account}
          sortedKeys={sortedKeys}
          includeKeys={includeKeys}
          excludeKeys={excludeKeys}
        />
      </CollapsibleCard>
    </Header>
  );
};
